<template>
    <section>
        <Breadcrumbs main="Account Settings" title="Account Upgrade" />
        <div class="container-fluid support-ticket-section">
      <div class="row">
        <div class="col-md-12">
        <div v-if="loading" class="loader-12"></div>
          <px-card :actions="false">
            <div slot="headerCustom">
              <h5 class="pull-right">{{step === 2 ? benefitDetails.title : ''}}</h5>
              <h5>Account Upgrade</h5>
              <span v-if="step === 1">Select upgrade Type</span>
            </div>
            <div slot="with-padding">
              <div class="row"  v-if="step === 1">
                <div class="col-xl-4 col-md-6 box-col-6 wrapper xl-50" v-for="items in cardItems" :key="items.id">
                  <div class="card ecommerce-widget" :class="items.title === 'Tier 2 Account' ? 'pb-4' : null" data-toggle="modal" data-target="#previewAccountDetails" @click="getBenefits(items)">
                    <div class="card-body support-ticket-font">
                      <div class="row">
                        <div class="col-7">
                          <h4 class="total-num counter">{{items.title}}</h4>
                          <span>Select to view details</span>
                        </div>
                        <div class="col-5">
                          <div class="text-md-right icon-wrapper">
                            <i class="fa fa-university text-danger fa-2x" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- DETAILS SECTION -->
              <section v-if="step === 2">
                <form @submit.prevent="step++">
                    <h6 class="font-weight-bold text-center mb-4">PERSONAL DETAILS </h6>
                    <div class="row">
                          <div class="col-lg-6">
                            <label class="col-form-label" for="name">Select Account <span class="text-danger">*</span></label>                             
                            <select class="form-control" v-model="form.accountNumber" required>
                                <option value="" disabled>Select Account</option>
                                <option v-for="account in userAccounts" :key="account.id" :value="account.accountNumber">{{account.accountNumber}} ({{account.accountName}})</option>
                            </select>
                          </div>

                          <div class="col-lg-6">
                            <label class="col-form-label">Marital Status <span class="text-danger">*</span></label>                             
                            <select class="form-control" v-model="customerDetails.maritalStatus" required>
                                <option value="" disabled>Select Marital Status</option>
                                <option v-for="(data, index) in maritalStatus" :key="index" :value="data.id">{{data.name}}</option>
                            </select>
                          </div>
                          <div class="col-lg-4 mt-3">
                            <label class="col-form-label">Mother Maiden's name <span class="text-danger">*</span></label>                             
                            <input class="form-control" required v-model="customerDetails.MotherMaidenName" type="text" placeholder="Mother Maiden's name">
                          </div>
                          <div class="col-lg-4 mt-3">
                            <label class="col-form-label">Country of Birth <span class="text-danger">*</span></label>                             
                            <select class="form-control" v-model="customerDetails.countryOfBirth" required>
                                <option value="" disabled>Select Country of Birth</option>
                                <option v-for="(data, index) in allCountries" :key="index" :value="data.name">{{data.name}}</option>
                            </select>
                          </div>

                          <div class="col-lg-4 mt-3">
                            <label class="col-form-label">Nationality <span class="text-danger">*</span></label>                             
                            <select class="form-control" v-model="customerDetails.nationality" required>
                                <option value="" disabled>Select Nationality</option>
                                <option v-for="(data, index) in allCountries" :key="index" :value="data.name">{{data.name}}</option>
                            </select>
                          </div>
                          <div class="col-lg-4 mt-3" v-if="customerDetails.nationality === 'Nigeria'">
                            <label class="col-form-label">State of Origin<span class="text-danger">*</span></label>                             
                            <select class="form-control" v-model="customerDetails.state" required>
                                <option value="" disabled>Select State of Origin</option>
                                <option v-for="(state, index) in allStates" :key="index" :value="state.id">{{state.name}}</option>
                            </select>
                          </div>

                          <div class="col-lg-4 mt-3" v-if="customerDetails.nationality === 'Nigeria'">
                            <label class="col-form-label">LGA of Origin <span class="text-danger">*</span></label>                             
                            <select class="form-control" v-model="customerDetails.lgaOfOrigin" required>
                                <option value="" disabled>Select LGA of Origin</option>
                                <option v-for="(data, index) in allLgas" :key="index" :value="data.name">{{data.name}}</option>
                            </select>
                          </div>
                          <!-- NON NIGERIAN -->
                          <div class="col-lg-4 mt-3" v-else>
                            <label class="col-form-label">State of Origin<span class="text-danger">*</span></label>                             
                            <input class="form-control" v-model="customerDetails.state" type="text" placeholder="State of Origin">
                          </div>

                          <div class="col-lg-4 mt-3" v-if="customerDetails.nationality !== 'Nigeria'">
                            <label class="col-form-label">LGA of Origin <span class="text-danger">*</span></label>                             
                            <input class="form-control" v-model="customerDetails.lgaOfOrigin" type="text" placeholder="LGA of Origin">
                          </div>
                          <!-- END NON NIGERIAN -->

                          <div class="col-lg-4 mt-3">
                            <label class="col-form-label">Foreigners Only<span class="text-danger">*</span></label>                             
                            <select class="form-control" v-model="customerDetails.isForeigner" required>
                                <option value="" disabled>Select if foreigner</option>
                                <option v-for="(data, index) in foreigners" :key="index" :value="data">{{ data ? 'Yes' : 'No' }}</option>
                            </select>
                          </div>
                    </div>
                    <div class="row mt-3 fadein" v-if="customerDetails.isForeigner">
                      <div class="col-lg-4">
                        <label class="col-form-label">Resident Permit Number <span class="text-danger">*</span></label>                             
                        <input class="form-control" v-model="customerDetails.foreignerAccountUpdate.residentPermitNumber" type="text" required placeholder="Resident Permit Number">
                      </div>
                      <div class="col-lg-4">
                        <label class="col-form-label">Resident Permit Issuance Date <span class="text-danger">*</span></label>                             
                        <input class="form-control" type="date" :max="currentDate" required placeholder="Issuance and expiry date" v-model="customerDetails.foreignerAccountUpdate.residentPermitIssuanceDate">
                      </div>
                      <div class="col-lg-4">
                        <label class="col-form-label">Resident Permit Expiry Date <span class="text-danger">*</span></label>                             
                        <input class="form-control" type="date" required placeholder="Resident Permit Expiry Date" v-model="customerDetails.foreignerAccountUpdate.residentPermitExpiryDate">
                      </div>
                    </div>
                    <div class="mb-3 row mt-4">
                        <div class="col-lg-12">
                            <button type="submit" class="btn btn-round btn-primary mr-2">Proceed<i class="fa fa-angle-right ml-1"></i></button>
                            <button type="button" class="btn btn-round btn-outline-danger" @click="goBackTo">Go Back</button>
                        </div>
                    </div>
                </form>
              </section>

              <!-- EMPLOYMENT DETAILS  -->
              <section v-if="step === 3">
                <form @submit.prevent="step++">
                    <h6 class="font-weight-bold text-center mb-4">EMPLOYMENT DETAILS</h6>
                    <div class="row">
                      <div class="col-lg-4 mt-3">
                        <label class="col-form-label">Employment Status <span class="text-danger">*</span></label>                             
                        <select class="form-control" v-model="customerEmploymentDetails.employmentStatus" required>
                            <option value="" disabled>Select Employment Status</option>
                            <option v-for="(data, index) in employmentStatus" :key="index" :value="data.id">{{data.name}}</option>
                        </select>
                      </div>
                      <div class="col-lg-4 mt-3" v-if="customerEmploymentDetails.employmentStatus === 1 || customerEmploymentDetails.employmentStatus === 2">
                        <label class="col-form-label">Date of Employment<span class="text-danger">*</span></label>                             
                        <input class="form-control" type="date" :max="currentDate" required placeholder="Date of Employment" v-model="customerEmploymentDetails.employmentDate">
                      </div>
                      <div class="col-lg-4 mt-3" v-if="customerEmploymentDetails.employmentStatus === 1 || customerEmploymentDetails.employmentStatus === 2">
                        <label class="col-form-label">Annual Turnover <span class="text-danger">*</span></label>                             
                        <input class="form-control" type="text" @keypress="isNumber" required placeholder="Annual Turnover" v-model.number="customerEmploymentDetails.annualTurnover">
                      </div>
                      <div class="col-lg-4 mt-3" v-if="customerEmploymentDetails.employmentStatus === 1 || customerEmploymentDetails.employmentStatus === 2">
                        <label class="col-form-label">Employer Name <span class="text-danger">*</span></label>                             
                        <input class="form-control" type="text" required placeholder="Employer Name" v-model="customerEmploymentDetails.employerName">
                      </div>

                      <div class="col-lg-4 mt-3" v-if="customerEmploymentDetails.employmentStatus === 1 || customerEmploymentDetails.employmentStatus === 2">
                        <label class="col-form-label">Employer Address <span class="text-danger">*</span></label>                             
                        <input class="form-control" type="text" required placeholder="Employer Address" v-model="customerEmploymentDetails.employerAddress">
                      </div>
                  
                      <div class="col-lg-4 mt-3" v-if="customerEmploymentDetails.employmentStatus === 1 || customerEmploymentDetails.employmentStatus === 2">
                        <label class="col-form-label">Nature of Business/Occupation<span class="text-danger">*</span></label>                             
                        <input class="form-control" type="text" required placeholder="Nature of Business/Occupation" v-model="customerEmploymentDetails.natureOfBusiness">
                      </div>

                      <div class="col-lg-4 mt-3" v-if="customerEmploymentDetails.employmentStatus === 1 || customerEmploymentDetails.employmentStatus === 2">
                        <label class="col-form-label">Office Phone Number</label>                             
                        <input class="form-control" maxlength="11" minlength="8" type="text" @keypress="isNumber" placeholder="Office Phone Number" v-model="customerEmploymentDetails.officePhoneNumber">
                      </div>
                    </div>
                    <div class="mb-3 row mt-4">
                        <div class="col-lg-12">
                            <button type="submit" class="btn btn-round btn-primary mr-2">Proceed<i class="fa fa-angle-right ml-1"></i></button>
                            <button type="button" class="btn btn-round btn-outline-danger" @click="goBackTo">Go Back</button>
                        </div>
                    </div>
                </form>
              </section>

              <!-- NEXT OF KIN DETAILS  -->
              <section v-if="step === 4">
                <form @submit.prevent="step++">
                    <h6 class="font-weight-bold text-center mb-4">NEXT OF KIN DETAILS </h6>
                    <div class="row">
                      <div class="col-lg-4">
                        <label class="col-form-label">Select Title <span class="text-danger">*</span></label>                             
                        <select class="form-control" required v-model="customerNextOfKinDetails.title">
                            <option value="" disabled>Select Title</option>
                            <option v-for="(data, index) in title" :key="index" :value="data.id">{{data.name}}</option>
                        </select>
                      </div>
                      <div class="col-lg-4">
                        <label class="col-form-label">Surname <span class="text-danger">*</span></label>                             
                        <input class="form-control" type="text" required placeholder="Surname" v-model="customerNextOfKinDetails.surname">
                      </div>
                      <div class="col-lg-4">
                        <label class="col-form-label">First Name <span class="text-danger">*</span></label>                             
                        <input class="form-control" type="text" required placeholder="First Name" v-model="customerNextOfKinDetails.firstname">
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-lg-4">
                          <label class="col-form-label">Other Names</label>                           
                          <input class="form-control" type="text" placeholder="Other Names" v-model="customerNextOfKinDetails.othername">
                        </div>

                        <div class="col-lg-4">
                          <label class="col-form-label">Date of Birth <span class="text-danger">*</span></label>                             
                          <input class="form-control" type="date" required placeholder="Date of Birth" v-model="customerNextOfKinDetails.dateOfBirth">
                        </div>

                        <div class="col-lg-4">
                          <label class="col-form-label">Relationship <span class="text-danger">*</span></label>                             
                          <select class="form-control" v-model="customerNextOfKinDetails.nextOfKinRelationship" required>
                              <option value="" disabled>Select Relationship</option>
                              <option v-for="(data, index) in nextOfKinRelationship" :key="index" :value="data.id">{{data.name}}</option>
                          </select>
                        </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-lg-4">
                          <label class="col-form-label">Gender <span class="text-danger">*</span></label>                             
                          <select class="form-control" required v-model="customerNextOfKinDetails.gender">
                              <option value="" disabled>Select Gender</option>
                              <option v-for="(data, index) in gender" :key="index" :value="data.id">{{data.name}}</option>
                          </select>
                        </div>

                        <div class="col-lg-4">
                          <label class="col-form-label">Phone Number 1 <span class="text-danger">*</span></label>                             
                          <input class="form-control" maxlength="14" v-model="customerNextOfKinDetails.phoneNumber1" required minlength="11" type="text" @keypress="isNumber" placeholder="Phone Number 1">
                        </div>

                        <div class="col-lg-4">
                          <label class="col-form-label">Phone Number 2</label>                             
                          <input class="form-control" maxlength="14" v-model="customerNextOfKinDetails.phoneNumber2" minlength="11" type="text" @keypress="isNumber" placeholder="Phone Number 2">
                        </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-lg-4">
                        <label class="col-form-label">Email</label>                             
                        <input class="form-control" type="email" v-model="customerNextOfKinDetails.emailAddress" placeholder="Email">
                      </div>
                      <div class="col-lg-4">
                        <label class="col-form-label">Country</label>                             
                        <select class="form-control" v-model="customerNextOfKinDetails.country">
                            <option value="" disabled>Select Country</option>
                            <option v-for="(data, index) in allCountries" :key="index" :value="data.name">{{data.name}}</option>
                        </select>
                      </div>

                      <div class="col-lg-4" v-if="customerNextOfKinDetails.country === 'Nigeria'">
                        <label class="col-form-label">State/Province</label>                             
                        <select class="form-control" v-model="customerNextOfKinDetails.stateOfOrigin">
                            <option value="" disabled>Select State/Province</option>
                            <option v-for="(state, index) in allStates" :key="index" :value="state.id">{{state.name}}</option>
                        </select>
                      </div>
                      <div class="col-lg-4" v-else>
                        <label class="col-form-label">State/Province</label>
                        <input class="form-control" v-model="customerNextOfKinDetails.stateOfOrigin" type="text" placeholder="State/Province">
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-lg-6">
                        <label class="col-form-label">City/Town</label>                             
                        <input class="form-control" v-model="customerNextOfKinDetails.city" type="text" placeholder="City/Town">
                      </div>

                      <div class="col-lg-6" v-if="customerNextOfKinDetails.country === 'Nigeria'">
                        <label class="col-form-label">LGA of Origin</label>                             
                        <select class="form-control" v-model="customerNextOfKinDetails.lgaOfOrigin">
                            <option value="" disabled>Select LGA of Origin</option>
                            <option v-for="(data, index) in allLgas" :key="index" :value="data.name">{{data.name}}</option>
                        </select>
                      </div>
                      <div class="col-lg-6" v-else>
                        <label class="col-form-label">LGA of Origin</label>  
                        <input class="form-control" v-model="customerNextOfKinDetails.lgaOfOrigin" type="text" placeholder="LGA of Origin">                           
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-lg-6">
                        <label class="col-form-label">Contact Address</label>                             
                        <textarea rows="5" v-model="customerNextOfKinDetails.contactAddress" class="form-control" placeholder="Contact Address"></textarea>
                      </div>

                      <div class="col-lg-6">
                        <label class="col-form-label">Nearest Bus stop</label>                             
                        <textarea rows="5" v-model="customerNextOfKinDetails.nearestBusStop" class="form-control" placeholder="Nearest Bus stop"></textarea>
                      </div>
                    </div>
                    <div class="mb-3 row mt-4">
                      <div class="col-lg-12">
                        <button type="submit" class="btn btn-round btn-primary mr-2">Proceed<i class="fa fa-angle-right ml-1"></i></button>
                        <button type="button" class="btn btn-round btn-outline-danger" @click="goBackTo">Go Back</button>
                      </div>
                    </div>
                </form>
              </section>

              <!-- DOCUMENT UPLOAD SECTION -->
              <section v-if="step === 5">
                <!-- Tier 3 current upgrde -->
                <form @submit.prevent="proceedUpgrade">
                  <section v-if="!mandateAvailablity">
                    <div class="mb-4 row">
                        <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="signature">Upload Signature <span class="text-danger">*</span></label>                             
                        <div class="col-sm-9 col-md-6">
                        <div class="file-upload">
                              <label for="upload" class="file-upload__label"><i class='icon-file'></i></label>
                              <input
                                  id="upload" 
                                  class="file-upload__input"
                                  ref="image"
                                  type="file"
                                  name="file-upload"
                                  accept="image/*"
                                  @change="uploadSignature"
                              />
                              <p v-if="signatureMessage" class="text-center" style="color: #E41613;"> Uploading Signature Please wait...</p>
                              <div class="mt-2 d-flex justify-content-center" v-if="signatureSuccess">
                                  <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                  <p style="color: #4BB543;"> Signature uploaded successfully</p>
                              </div>
                          </div>
                        </div>
                    </div>
                    <div class="mb-4 row">
                        <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="uploadPhoto">Your photo <span class="text-danger">*</span></label>                             
                        <div class="col-sm-9 col-md-6">
                          <div class="file-upload">
                                <label for="uploadPhoto" class="file-upload__label"><i class='fa fa-user-circle-o'></i></label>
                                <input
                                    id="uploadPhoto" 
                                    class="file-upload__input"
                                    type="file"
                                    name="file-upload-photo"
                                    accept="image/*"
                                    @change="uploadPhoto"
                                />
                                <div class="mt-2 d-flex justify-content-center" v-if="isPhotoUploaded">
                                    <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                    <p style="color: #4BB543;"> Photo uploaded successfully</p>
                                </div>
                          </div>
                        </div>
                    </div>
                  </section>
                  <p v-if="isMandate" class="text-center text-danger">Please Wait...</p>
                  <div class="mb-3 row">
                      <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="idType">Select ID type <span class="text-danger">*</span></label>                             
                      <div class="col-sm-9 col-md-6">
                        <select class="form-control" @input="seletctIdTypes" id="idType" name="idType">
                            <option value="">Select ID type</option>
                            <option v-for="id in idTypes" :value="id.id" :key="id.id">{{id.description}}</option>
                        </select>
                      </div>
                      <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label mt-4">ID Number <span class="text-danger">*</span></label>                             
                      <div class="col-sm-9 col-md-6 mt-4">
                        <input class="form-control" type="text" required placeholder="ID Number" v-model="form.idNumber">
                        <div class="file-upload mt-3">
                            <label for="UploadID" class="file-upload__label"><i class='fa fa-id-card-o'></i></label>
                            <input
                                id="UploadID" 
                                class="file-upload__input"
                                ref="image"
                                type="file"
                                name="file-upload"
                                accept="image/*"
                                @change="uploadId"
                            />
                            <p v-if="IDMessage" class="text-center" style="color: #E41613;"> Uploading ID Please wait...</p>
                            <div class="mt-2 d-flex justify-content-center" v-if="idUploadSucces">
                                <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                <p style="color: #4BB543;"> ID uploaded successfully</p>
                            </div>
                        </div>
                      </div>
                  </div>
                  <section>
                    <div class="mb-3 row">
                      <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="utilitybill">Utility Bill <span class="text-danger">*</span></label>                             
                      <div class="col-sm-9 col-md-6">
                        <div class="file-upload mt-3">
                              <label for="utilityBill" class="file-upload__label"><i class='icon-file'></i></label>
                              <input
                                  id="utilityBill" 
                                  class="file-upload__input"
                                  ref="image"
                                  type="file"
                                  name="file-upload"
                                  accept="image/*"
                                  @change="setUtilityBill"
                              />
                              <p v-if="utlityMessage" class="text-center" style="color: #E41613;"> Uploading Utility Bill Please wait...</p>
                              <div class="mt-2 d-flex justify-content-center" v-if="utilityBillSuccess">
                                  <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                  <p style="color: #4BB543;"> Utility Bill uploaded successfully</p>
                              </div>
                          </div>
                        </div>
                    </div>
                    <div class="mb-3 row" v-if="benefitDetails.title === 'Tier 3 Account(current)'">
                      <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="ref">Reference Form {{ benefitDetails.title === 'Tier 3 Account(current)' ? '1' : ''}} <span class="text-danger">*</span></label>                             
                      <div class="col-sm-9 col-md-6">
                        <div class="file-upload mt-3">
                              <label for="ref" class="file-upload__label"><i class='icon-file'></i></label>
                              <input
                                  id="ref" 
                                  class="file-upload__input"
                                  ref="image"
                                  type="file"
                                  name="file-upload"
                                  accept="image/*"
                                  @change="uploadRefOne"
                              />
                              <p v-if="refOneMessage" class="text-center" style="color: #E41613;"> Uploading Reference Form Please wait...</p>
                              <div class="mt-2 d-flex justify-content-center" v-if="refOneSuccess">
                                  <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                  <p style="color: #4BB543;"> Reference Form uploaded successfully</p>
                              </div>
                          </div>
                        </div>
                    </div>
                    <div class="mb-3 row">
                      <label class="col-sm-3 col-md-3 offset-md-1 col-lg-2 offset-lg-2 col-form-label" for="ref2">Reference Form {{ benefitDetails.title === 'Tier 3 Account(current)' ? '2' : ''}} <span class="text-danger">*</span></label>                             
                      <div class="col-sm-9 col-md-6">
                        <div class="file-upload mt-3">
                              <label for="ref2" class="file-upload__label"><i class='icon-file'></i></label>
                              <input
                                  id="ref2" 
                                  class="file-upload__input"
                                  ref="image"
                                  type="file"
                                  name="file-upload"
                                  accept="image/*"
                                  @change="uploadRefTwo"
                              />
                              <p v-if="refTwoMessage" class="text-center" style="color: #E41613;"> Uploading Reference Form Please wait...</p>
                              <div class="mt-2 d-flex justify-content-center" v-if="refTwoSuccess">
                                  <feather style="color: #4BB543;" class="mr-1" type="check"></feather>
                                  <p style="color: #4BB543;"> Reference Form uploaded successfully</p>
                              </div>
                          </div>
                        </div>
                    </div>
                  </section>
                  <div class="set-margin">
                    <input style="background-color: red;" type="checkbox" name="checkbox" value="check" v-model="checked"/> I have read and agree to the <a href="https://digitaltest.tajbank.com/files/DudChequeAgreement.pdf" target="_blank" class="primary-color">Consent Information</a> &nbsp;<br /><br />
                  </div>
                  <div class="mb-3 row mt-4 button-wrapper">
                      <label class="col-sm-3 col-form-label"></label>
                      <div class="col-sm-9 col-xl-7">
                          <button type="submit" class="btn btn-round btn-primary mr-2">Proceed<i class="fa fa-angle-right ml-1"></i></button>
                          <button type="button" class="btn btn-round btn-outline-danger" @click="goBackTo">Go Back</button>
                      </div>
                  </div>
                </form>
              </section>
               <!--END  DOCUMENT UPLOAD SECTION -->

               <!-- TRANSCTION PIN SECTION -->
              <div v-if="step === 6">
                <form @submit.prevent="upgradeAccountRequest">
                  <div class="mb-3 row">
                      <label class="col-sm-3 col-form-label" for="Token">Transaction Pin <span class="text-danger">*</span></label>
                      <div class="col-sm-9 col-xl-7">
                          <input @keypress="isNumber" @paste.prevent minlength="4" maxlength="4" class="form-control" v-model="form.transactionPIN" pattern="\d*" placeholder="Enter Your Transaction Pin *" required :type="type"/>
                          <div class="show-hide" @click="showPin"><p class="show-text-info">{{type === 'password' ? 'show' : 'hide'}}</p></div>
                      </div>
                  </div>
                  <br />
                  <div class="mb-3 row">
                      <div class="col-sm-12 text-center">
                          <button type="submit" class="btn btn-primary mr-2">
                            <div v-if="loading">
                              <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                            </div>
                            <div v-else>
                              Submit <i class="fa fa-check mr-2"></i>
                            </div>
                          </button>
                          <button type="button" class="btn btn-outline-danger" @click="step--">Go Back</button>
                      </div>
                  </div>
                </form>
              </div>
              <!-- Request Success Response -->
              <div v-if="step === 7" class="animated fadeIn">
                <div class="card-body">
                    <div class="align-content-center align-items-center justify-content-center p-2 text-center">
                        <img src="@/assets/TAJimages/notification/success.png" alt="Error Icon image" class="img-fluid" />
                        <h5 class="text-bold-700 mb-2 text-success"><i class="feather icon-check-circle fa-2x"></i>ACCOUNT UPGRADE REQUEST LOGGED <br> SUCCESSFULLY!</h5>
                        <p>We're happy to see you scale. Do much more with TAJBank.</p>
                        <router-link to="/dashboard/default">
                            <a class="btn btn-primary btn-round">Go To Home<i class="fa fa-home ml-2"></i></a>
                        </router-link>
                    </div>
                </div>
              </div>
            </div>
          </px-card>
        </div>
      </div>
    </div>
    <!--modal to preview -->
    <div class="modal fade" id="previewAccountDetails" tabindex="-1" role="dialog" aria-labelledby="accountPreview" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title pl-2" id="accountPreview" style="font-size: 18px">{{benefitDetails.title}}</h5>
                <button class="close text-dark" type="button" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
                <div class="modal-body p-4">
                    <h5 class="text-dark">Benefits</h5>
                    <table class="table table-striped">
                      <tbody>
                          <tr>
                              <td>Mobile Transaction Limit(Per Transaction)</td>
                              <td></td>
                              <td><span class="font-weight-bold">{{benefitDetails.limitPerTransaction}}</span></td>
                          </tr>
                          <tr>
                              <td>Mobile Daily Transaction Limit</td>
                              <td></td>
                              <td><span class="font-weight-bold">{{benefitDetails.dailyTransactionLimit}}</span></td>
                          </tr>
                          <tr>
                              <td>Single(account) Transaction Limit</td>
                              <td></td>
                              <td><span class="font-weight-bold">{{benefitDetails.singleTransactionLimit}}</span></td>
                          </tr>
                            <h5 class="pt-4 pb-3 pl-2">Account Balance</h5>
                          <tr>
                              <td>Maximum Available Balance</td>
                              <td></td>
                              <td><span class="font-weight-bold">{{benefitDetails.maxAvailableBalance}}</span></td>
                          </tr>
                      </tbody>
                    </table>
                    <div class="mb-5">
                      <h5 class="pt-4 pb-3 text-dark">What you need for the application:</h5>
                      <div class="d-flex align-items-center">
                        <feather type="camera" class="text-danger mr-3"/>
                        <span class="text-dark font-weight-bold">Live selfie (photo)</span>
                      </div>
                      <div class="mt-4 d-flex">
                        <div>
                          <feather type="users" class="text-danger mr-3"/>
                        </div>
                        <div>
                          <span class="text-dark mb-3 font-weight-bold">Other Personal Details</span>
                          <p class="text-dark">Marital status / Nationality / Country of birth</p>
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <feather type="clipboard" class="text-danger mr-3"/>
                        <span class="text-dark font-weight-bold">Employment Details</span>
                      </div>
                      <div class="d-flex mt-4 align-items-center">
                        <feather type="users" class="text-danger mr-3"/>
                        <span class="text-dark font-weight-bold">Next of Kin Details</span>
                      </div>
                      <div class="mt-4 d-flex">
                        <div>
                          <feather type="clipboard" class="text-danger mr-3"/>
                        </div>
                        <div>
                          <span class="text-dark mb-3 font-weight-bold">Valid ID</span>
                          <p class="text-dark">National ID / Permanent Voter's ID / Driver's License / International Passport</p>
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <feather type="file-text" class="text-danger mr-3"/>
                        <span class="text-dark font-weight-bold">Utility bill</span>
                      </div>
                      <div class="mt-4 d-flex">
                        <div>
                          <feather type="file" class="text-danger mr-3"/>
                        </div>
                        <div>
                          <span class="text-dark mb-3 font-weight-bold">{{ benefitDetails.title == 'Tier 3 Account(current)' ? 2 : 1}} {{ benefitDetails.title == 'Tier 3 Account(current)' ? 'References' : 'Reference'}} </span>
                          <p class="text-dark">Download, fill and upload referees details.</p>
                        </div>
                      </div>
                    </div>
                    <section class="d-flex justify-content-between">
                      <div class="form--input text-center">
                        <a href="https://digitaltest.tajbank.com/files/ReferenceForm.pdf" target="_blank" Download class="ref-btn mt-3 btn-lg">Download Reference Form</a>
                      </div>
                      <div class="text-center">
                          <button class="proceed-btn" type="button" @click="gotoPage">Proceed</button>
                      </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
    </section>
</template>
<script>
  import $ from 'jquery';
  import { mapState, mapActions } from 'vuex';
  import { decrypt } from '@/_services/encryption';
  export default {
    data:() => ({
      cardItems:[
        { id: 1, title: 'Tier 3 Account(current)', limitPerTransaction: 'N1,000,000.00', dailyTransactionLimit: 'N1,000,000.00', singleTransactionLimit: 'N1,000,000.00', maxAvailableBalance: 'Unlimited' },
        { id: 2, title: 'Tier 3 Account(Hybrid)', limitPerTransaction: 'N1,000,000.00', dailyTransactionLimit: 'N1,000,000.00', singleTransactionLimit: 'N1,000,000.00', maxAvailableBalance: 'Unlimited' },
      ],
      benefitDetails: {
        title: '',
        limitPerTransaction: '',
        dailyTransactionLimit: '',
        singleTransactionLimit: '',
        maxAvailableBalance: '',
      },
      'customerDetails': {
        'countryOfBirth': '',
        'nationality': '',
        state: '',
        MotherMaidenName: '',
        'lgaOfOrigin': '',
        'maritalStatus': '',
        'isForeigner': false,
        'foreignerAccountUpdate': {
          'residentPermitNumber': '',
          'residentPermitIssuanceDate': null,
          'residentPermitExpiryDate': null
        },
      },
      'customerEmploymentDetails': {
        'employmentStatus': '',
        'employmentDate': null,
        'annualTurnover': null,
        'employerName': '',
        'employerAddress': '',
        'natureOfBusiness': '',
        'officePhoneNumber': ''
      },
      'customerNextOfKinDetails': {
        'title': '',
        'surname': '',
        'firstname': '',
        'othername': '',
        'dateOfBirth': '',
        'nextOfKinRelationship': '',
        'gender': '',
        'phoneNumber1': '',
        'phoneNumber2': '',
        'emailAddress': '',
        'contactAddress': '',
        'nearestBusStop': '',
        'country': '',
        'stateOfOrigin': '',
        'lgaOfOrigin': '',
        city: ''
      },
      'customerDocumentDetails': {
        'photo': '',
        'signature': '',
        documents: []
      },
      form: {
        accountNumber: '',
        meansOfIdentification: '',
        idNumber: '',
        foreigners: '',
        documents: [],
        upgradeType: '',
        photo: '',
        signature: '',
        transactionPIN: '',
        platform: 1,
        state: ''
      },
      documents: [
        { verificationId: null, fileName: null, document: null, documentType: null },
        { verificationId: null, fileName: null, document: null, documentType: null },
        { verificationId: null, fileName: null, document: null, documentType: null },
        { verificationId: null, fileName: null, document: null, documentType: null },
      ],
      checked: false,
      document: null,
      documentType: null,
      utilityBillSuccess: false,
      utlityMessage: false,
      signatureMessage: false,
      signatureSuccess: false,
      IDMessage: false,
      idUploadSucces: false,
      refOneMessage: false,
      refOneSuccess: false,
      refTwoMessage: false,
      refTwoSuccess: false,
      isPhotoUploaded: false,
      step: 1,
      loading: false,
      type: 'password',
      isMandate: false,
      foreigners: [true, false],
    }),
    computed: {
      ...mapState({
        idTypes: state => state.authentication.idTypes,
        allStates: state => state.authentication.states,
        gender: state => state.authentication.gender,
        allLgas: state => state.authentication.lga,
        // eslint-disable-next-line no-confusing-arrow
        userAccounts: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts : [],
        // eslint-disable-next-line no-confusing-arrow
        mandateAvailablity: state => state.dashboard ? state.dashboard.mandateAvailablity : false,
        userDetails: state => state.dashboard.dashboardData.customerDetails.email,
      }),
      ...mapState('flight',['allCountries']),
      ...mapState('settings',['maritalStatus', 'title', 'nextOfKinRelationship', 'employmentStatus']),
      currentDate() {
        return new Date().toISOString().split('T')[0];
      }
    },
    watch: {
      async 'customerDetails.state' (newVal) {
        await this.getLga(newVal);
      },
      async 'customerNextOfKinDetails.stateOfOrigin' (newVal) {
        await this.getLga(newVal);
      },
      async 'form.accountNumber' (newVal) {
        this.isMandate = true;
        await this.getMandateAvailablity(newVal);
        this.isMandate = false;
      }
    },
    async mounted(){
      this.$store.dispatch('getIdTypes');
      await this.getDashboardData();
      await this.getStates();
      await this.getAllCountries();
      await this.getMaritalStatus();
      await this.getTitle();
      await this.getNextOfKinRelationship();
      await this.getEmploymentStatus();
      await this.getGender();
    },
    methods: {
      ...mapActions(['getStates', 'getLga', 'getGender']),
      ...mapActions('flight',['getAllCountries']),
      ...mapActions('settings', ['upgradeAccountNew', 'getMaritalStatus', 'getTitle', 'getNextOfKinRelationship', 'getEmploymentStatus']),
      ...mapActions('dashboard', ['getDashboardData', 'getMandateAvailablity']),
      getBenefits(val) {
        this.benefitDetails.title = val.title;
        this.benefitDetails.limitPerTransaction = val.limitPerTransaction;
        this.benefitDetails.dailyTransactionLimit = val.dailyTransactionLimit;
        this.benefitDetails.singleTransactionLimit = val.singleTransactionLimit;
        this.benefitDetails.maxAvailableBalance = val.maxAvailableBalance;
      },
      uploadSignature(event) {
        const input = event.target;
        if (input.files) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileData = e.target.result.replace('data:', '').replace(/^.+,/, '');
            this.customerDocumentDetails.signature = fileData;
            this.signatureSuccess = true;
          };
          reader.readAsDataURL(input.files[0]);
        }
      },
      uploadPhoto(event) {
        const input = event.target;
        if (input.files) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileData = e.target.result.replace('data:', '').replace(/^.+,/, '');
            this.customerDocumentDetails.photo = fileData;
            this.isPhotoUploaded = true;
          };
          reader.readAsDataURL(input.files[0]);
        }
      },
      setUtilityBill(event) {
        this.clearObject(this.customerDocumentDetails.documents, 'documentType', 5);
        this.utilityBillSuccess = false;
        const input = event.target;
        if (input.files) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileData = e.target.result.replace('data:', '').replace(/^.+,/, '');
            this.documents[0].document = fileData;
          };
          reader.readAsDataURL(input.files[0]);
        }
        const fileName = event.target.files[0].name;
        const documentType = 5;
        this.utilityBillSuccess = true;
        setTimeout(() => {
          this.customerDocumentDetails.documents.push({ documentType, fileName, document: this.documents[0].document });
        }, 200);
      },
      seletctIdTypes(event) {
        this.documentType = event.target.value;
      },
      uploadId(event) {
        this.idUploadSucces = false;
        this.clearObject(this.customerDocumentDetails.documents, 'documentType', 1);
        if (this.documentType === null) {
          this.$toasted.show('Please select ID type', { 
            theme: 'outline',
            position: 'top-right',
            icon : 'times', 
            type: 'error', 
            duration: 4000 
          });
        }else {
          const input = event.target;
          if (input.files) {
            const reader = new FileReader();
            reader.onload = (e) => {
              const fileData = e.target.result.replace('data:', '').replace(/^.+,/, '');
              this.documents[1].document = fileData;
            };
            reader.readAsDataURL(input.files[0]);
          }
          const fileName = event.target.files[0].name;
          this.idUploadSucces = true;
          this.documentType = parseInt(this.documentType);
          setTimeout(() => {
            this.customerDocumentDetails.documents.push({ documentType: this.documentType, fileName, identificationNumber: this.form.idNumber, document: this.documents[1].document });
          }, 200);
        }
      },
      uploadRefOne(event) {
        this.refOneUploadSucces = false;
        this.clearObject(this.customerDocumentDetails.documents, 'documentType', 11);
        const input = event.target;
        if (input.files) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileData = e.target.result.replace('data:', '').replace(/^.+,/, '');
            this.documents[2].document = fileData;
          };
          reader.readAsDataURL(input.files[0]);
        }
        const fileName = event.target.files[0].name;
        const documentType = 11;
        this.refOneSuccess = true;
        setTimeout(() => {
          this.customerDocumentDetails.documents.push({ documentType, fileName, document: this.documents[2].document });
        }, 200);
      },
      uploadRefTwo(event) {
        this.refTwoUploadSucces = false;
        // this.clearObject(this.form.documents, 'documentType', 11);
        const input = event.target;
        if (input.files) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const fileData = e.target.result.replace('data:', '').replace(/^.+,/, '');
            this.documents[3].document = fileData;
          };
          reader.readAsDataURL(input.files[0]);
        }
        const fileName = event.target.files[0].name;
        const documentType = 11;
        this.refTwoSuccess = true;
        setTimeout(() => {
          this.customerDocumentDetails.documents.push({ documentType, fileName, document: this.documents[3].document });
        }, 200);
      },
      proceedUpgrade() {
        if(!this.mandateAvailablity) {
          if (this.customerDocumentDetails.documents.length < 3 || this.customerDocumentDetails.signature === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Kindly upload all required documents',
              type: 'error',
            });
          } else if(!this.checked) {
            this.$swal({
              title: 'Oops...',
              text: 'Please accept consent Information',
              type: 'error',
            });
          } else {
            this.step++;
          }
        } else {
          if (this.customerDocumentDetails.documents.length < 3) {
            this.$swal({
              title: 'Oops...',
              text: 'Kindly upload all required documents',
              type: 'error',
            });
          } else if(!this.checked) {
            this.$swal({
              title: 'Oops...',
              text: 'Please accept consent Information',
              type: 'error',
            });
          } else {
            this.step++;
          }
        }
      },
      async upgradeAccountRequest () {
        const data = {
          customerDetails: this.customerDetails,
          customerEmploymentDetails:this.customerEmploymentDetails,
          customerNextOfKinDetails: this.customerNextOfKinDetails,
          customerDocumentDetails: this.customerDocumentDetails,
          accountNumber: this.form.accountNumber,
          upgradeType: this.form.upgradeType,
          transactionPIN: this.form.transactionPIN,
          platform: 1
        };
        try {
          this.loading = true;
          await this.upgradeAccountNew(data);
          this.loading = false;
          this.step++;
        } catch (error) {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title: 'Oops...',
            text: objError.errors[0],
            type: 'error',
          });
        }
      },
      // function to clear object in the array if document type exists
      clearObject(array, key, value) {
        array.forEach((item, index) => {
          if (item[key] === value) {
            array.splice(index, 1);
          }
        });
      },
      resetForm() {
        // reset form 
        this.form.accountNumber = '';
        this.form.documents = [];
        this.form.upgradeType = '';
        this.form.photo = '';
        this.form.signature = '';
        this.form.transactionPIN = '';
        this.idUploadSucces = false;
        this.signatureSuccess = false;
        this.refOneSuccess = false;
        this.refTwoSuccess = false;
        this.utilityBillSuccess = false;
        this.checked = false;
        this.isPhotoUploaded = false;
      },
      gotoPage() {
        $('#previewAccountDetails').modal('hide');
        this.step++;
        this.resetForm();
        if(this.benefitDetails.title === 'Tier 3 Account(current)') {
          this.form.upgradeType = 3;
        } else {
          this.form.upgradeType = 4;
        }
      },
      goBackTo() {
        this.step--;
      },
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
    }
  };
</script>
<style scoped>
.icon-wrapper {
    border-radius: 7px;
    background-color: #fff0e4;
    padding: 15px;
    height: 100%;
    width: 60px;
    text-align: right;
    float: right;
}
.wrapper {
  cursor: pointer;
}
.proceed-btn  {
  background-color: #E41613;
  color: #fff;
  border-radius: 10px;
  padding: 10px;
  height: 45px;
  width: 200px;
  font-size: 14px;
  font-weight: bold;
  /* margin-top: 5px; */
  border: none;
}
.ref-btn {
  background-color: #fff;
  color: #E41613;
  border-radius: 10px;
  padding: 10px;
  height: 45px;
  width: 100%;
  font-weight: bold;
  padding: 12px 10px;
  font-size: 14px;
  letter-spacing: 0px;
  margin-top: 5px;
  border: 1px solid #E41613;
}
.modal-dialog-scrollable {
  overflow: hidden;
}
.needs-header {
  font-weight: 400;
}
.form-control {
  width: 100% !important;
}
.bvn-form input {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    padding: 0 10px;
    font-size: 16px;
    color: #000;
    margin-bottom: 15px;
}
.bvn-form input::placeholder {
    color: #ACACAC;
    font-size: 14px;
    font-weight: 300;
    text-align: left;
}
.file-upload {
	position: relative;
	display: inline-block;
  width: 100%;
}
 .file-upload__label {
	display: block;
	border: 3px solid #DF351712 !important;
  background-color: #DF351708 !important;
  border-radius: 10px !important;
  width: 100%;
  height: 100px;
  text-align: center;
  padding: 30px 0px;
}
 .file-upload__label:hover {
	cursor: pointer;
}
 .file-upload__input {
	position: relative;
    display: none;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	font-size: 1;
	width: 0;
	height: 100%;
	opacity: 0;
}
.file-upload__label .fa-id-card-o,
.file-upload__label .fa-user-circle-o,
.file-upload__label .icon-file {
    color: #E41613;
    font-size: 25px;
}
.support-ticket-font .total-num {
  font-size: 20px;
  font-weight: 500;
}
.show-text-info {
  color: #E41613;
  margin-right: 0px;
  margin-top: 5px;
  cursor: pointer;
}
.form--input  {
  margin: 10px 0;
}
.set-margin {
  margin-left: 100px;
  text-align: center;
}
.button-wrapper {
  margin-left: 100px;
}
@media screen and (max-width: 768px) {
  .set-margin {
    margin-left: 0;
    text-align: left;
  }
  .button-wrapper {
    margin-left: 0px;
    margin-top: 10px;
  }
  .support-ticket-font .total-num {
    font-size: 16px;
  }
  .ecommerce-widget span {
    font-size: 13px;
  }
}
</style>